var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSidebarStudentsActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1AA99D69-2F2E-47FC-9B19-A6B299799D0E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17,2 C18.6568542,2 20,3.34314575 20,5 L20,15 C20,16.6568542 18.6568542,18 17,18 L3,18 C1.34314575,18 0,16.6568542 0,15 L0,5 C0,3.34314575 1.34314575,2 3,2 L17,2 Z M17,4 L3,4 C2.44771525,4 2,4.44771525 2,5 L2,15 C2,15.5522847 2.44771525,16 3,16 L17,16 C17.5522847,16 18,15.5522847 18,15 L18,5 C18,4.44771525 17.5522847,4 17,4 Z M7.49944391,6 C8.12317025,6 8.58299769,6.15892977 8.8663717,6.47237458 C9.19306579,6.83371237 9.16271415,7.27170568 9.15498827,7.34528428 L9.15498827,8.05685618 C9.24328397,8.15438127 9.2929503,8.27919732 9.2929503,8.40802675 L9.2929503,8.9431438 C9.2929503,9.15384615 9.16657708,9.34046822 8.97191266,9.4270234 C8.87230407,9.70809364 8.73530778,9.96869564 8.56437282,10.2028094 L8.46517812,10.3300334 L8.46517812,10.7823411 C8.46517812,10.9171906 8.54243686,11.0383946 8.66674065,11.0987291 L9.51378532,11.5085311 C9.61014953,11.5263015 9.69391112,11.554718 9.7650701,11.5937805 C10.482838,11.9461924 10.8395074,12.3553933 10.9729391,13.1143126 L10.9941966,13.2519294 C11.0429496,13.6147395 10.7791602,13.9471791 10.4050064,13.994454 L10.3167313,14 L4.69057327,14 C4.30918018,14 4,13.7001958 4,13.3303659 C4,13.3008566 4.0020116,13.2713795 4.00602165,13.2421274 C4.08716771,12.6501925 4.28696868,12.2594631 4.6616743,11.950419 L4.83771196,11.8157356 L4.9046078,11.7714564 L5.11837996,11.6526304 L5.25030672,11.585035 L6.20577395,11.0802675 C6.32290371,11.018194 6.39574766,10.899398 6.39574766,10.7698997 L6.39574766,10.3272241 L6.33662966,10.2484665 C6.21899148,10.0847046 6.01777769,9.76341136 5.91246667,9.35906354 C5.78223051,9.25779263 5.70593751,9.10595317 5.70593751,8.9431438 L5.70593751,8.40802675 C5.70593751,8.27919732 5.75560384,8.15438127 5.84389954,8.05685618 L5.84389954,7.34528428 L5.84050245,7.29745639 L5.84036154,7.20904196 C5.84686147,7.03422684 5.89657038,6.73320698 6.13251611,6.4722408 C6.41589012,6.15892977 6.87571757,6 7.49944391,6 Z M15,11 C15.5522847,11 16,11.4477153 16,12 C16,12.5522847 15.5522847,13 15,13 L13.5,13 C12.9477153,13 12.5,12.5522847 12.5,12 C12.5,11.4477153 12.9477153,11 13.5,11 L15,11 Z M15,7 C15.5522847,7 16,7.44771525 16,8 C16,8.55228475 15.5522847,9 15,9 L12,9 C11.4477153,9 11,8.55228475 11,8 C11,7.44771525 11.4477153,7 12,7 L15,7 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Studenti",
    transform: "translate(-20.000000, -203.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(0.000000, 61.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3,
    transform: "translate(0.000000, 132.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(20.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Sidebar-/-Students",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "viewbox",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Icon-color",
    fill: "#0883EF",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidebarStudentsActive);
export default __webpack_public_path__ + "static/media/ic-sidebar-students-active.8c480566ed13f112ff66e1dcefcd6506.svg";
export { ForwardRef as ReactComponent };